export const getFormName = form => {
  var _form$properties;
  const formName = (_form$properties = form.properties) == null ? void 0 : _form$properties.name;
  return formName ?? undefined;
};
//# sourceMappingURL=get-form-name.js.map